import t from 'prop-types';
import { generateTable } from '../../table/Table';
import { fetchCategories } from '../../../apis';
import { defineFilter } from '../../../helpers';
var clientSide = defineFilter(true).startsWith('name', 'name').startsWith('slug', 'slug').end();

var dataSource = function dataSource(_ref) {
  var kappSlug = _ref.kappSlug;
  return {
    fn: fetchCategories,
    clientSide: clientSide,
    params: function params() {
      return [{
        include: 'details',
        kappSlug: kappSlug
      }];
    },
    transform: function transform(result) {
      return {
        data: result.categories
      };
    }
  };
};

var filters = function filters() {
  return function () {
    return [{
      name: 'name',
      label: 'Name',
      type: 'text'
    }, {
      name: 'slug',
      label: 'Slug',
      type: 'text'
    }];
  };
};

var columns = [{
  value: 'name',
  title: 'Name',
  sortable: true
}, {
  value: 'slug',
  title: 'Slug',
  sortable: true
}, {
  value: 'createdAt',
  title: 'Created',
  sortable: true
}, {
  value: 'createdBy',
  title: 'Created By',
  sortable: true
}, {
  value: 'updatedAt',
  title: 'Updated',
  sortable: true
}, {
  value: 'updatedBy',
  title: 'Updated By',
  sortable: true
}];
export var CategoryTable = generateTable({
  tableOptions: ['kappSlug'],
  columns: columns,
  filters: filters,
  dataSource: dataSource
});
CategoryTable.propTypes = {
  /** The Slug of the kapp to display categories for */
  kappSlug: t.string.isRequired
};
CategoryTable.displayName = 'CategoryTable';